import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { TID } from "@/lib/testIds";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#090A0F] text-slate-100 px-6">
      <div className="max-w-md w-full aq-card p-8 text-center">
        <div className="w-14 h-14 mx-auto rounded-full bg-amber-500/20 grid place-items-center">
          <XCircle className="w-7 h-7 text-amber-400" />
        </div>
        <h1 data-testid={TID.paymentCancelTitle} className="mt-4 font-display text-3xl font-extrabold">Payment cancelled</h1>
        <p className="mt-2 text-sm text-slate-400">No worries — no card was charged. You can subscribe any time to unlock the trading terminal.</p>
        <Button onClick={() => navigate("/", { replace: true })}
          className="mt-6 w-full h-11 rounded-full bg-white/10 hover:bg-white/20 text-white">
          Back to home
        </Button>
      </div>
    </div>
  );
}
